module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "sidebar"
  }, [_c('h3', {
    staticClass: "h3"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("FIVE REASONS TO INVEST IN REAL ESTATE")])])]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_c('p', {
    staticClass: "chap-tit"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("Build Your Fortune")])])])]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("There are five key reasons to invest in real estate, and one potential disadvantage. That drawback is limited liquidity, which means you can’t transform your investment into cash immediately (and sometimes not for an extremely long time). While that’s true about direct real estate investing (buying a property to rent, hold, or flip), there are many ways to invest in real estate that eliminate that issue and still offer you all of the plusses of this resilient asset class.")]), _vm._v(" "), _c('h4', {
    staticClass: "h4a"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("IT’S REAL")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Unlike the most popular investments—stocks, bonds, and mutual funds—real estate is tangible. You can see it, touch it, and stand on it. It’s not an idea like bitcoin or stock options, and it doesn’t exist only on a financial statement or an exchange: it’s real. That means you have something of value even if the current market value falls to zero, unlike a stock or bond that would be worthless in a crash.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("You can use your real estate even if the market considers it valueless. You can live there or turn it into productive space (using it to grow food, for example). And even indirect real estate investments are largely based on physical assets, which allow them to hold a more stable value even in a volatile market.")])]), _c('p', {
    staticClass: "shead"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("Limited Supply")])])]), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("There’s a finite amount of usable land in the world, a limited supply. People need places to live and work, and as the population continues to grow, the demand for space grows right along with it. On top of that, we need land to produce food and deliver natural resources, from timber to oil to the elements that power our laptops.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Other investment assets are not finite. Corporations can issue more shares of stock. Governments and corporations can create more bonds to sell. And while land can be transformed to serve a new purpose, it can’t be created from thin air.")]), _vm._v(" "), _c('p', {
    staticClass: "shead"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("More Control")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When you own real property, you have more control over your investment than if you owned stock (a small portion of a company) or other paper-based assets. For example, you can do things to make your property more valuable, like spring for a new roof. You can affect the income by catering to more financially solid tenants and raising the rent. The flip side of that is your investment requires more active management. You have to maintain and repair it, or pay someone else to do so.")]), _vm._v(" "), _c('h4', {
    staticClass: "h4a"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("REAL ESTATE DIVERSIFIES YOUR PORTFOLIO")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Diversification is a crucial part of successful wealth building. By combining many different types of investments in a portfolio, the risk of the total portfolio losing value is greatly minimized. That’s especially true if your portfolio includes investments that don’t act in the same ways as each other.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("In theory, diversification helps smooth out the ups and downs of the markets and increase income potential. When one type of asset is drowning, another could be soaring, and that balance helps keep your overall portfolio steadier.")])]), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_c('p', {
    staticClass: "shead"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("The Correlation Factor")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Real estate doesn’t act like other investments, and that holds true even if the real estate investment gets bought and sold like stock. That’s because real estate has a low or negative correlation to many major types of investments. When you add real estate into a portfolio, it helps balance the ups and downs (called volatility in the investment world), which lowers your risk of total loss.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Here’s how that works: say real estate has a low correlation to other assets in your portfolio. If those other asset values plummet, real estate will just dip slightly; if the other assets skyrocket, real estate will take a few steps up. It won’t be as dramatic, and it won’t be as heartbreaking.")]), _vm._v(" "), _c('p', {
    staticClass: "box-head"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("Correlation")])]), _vm._v(" "), _c('hr', {
    staticClass: "hr1"
  }), _vm._v(" "), _c('p', {
    staticClass: "box"
  }, [_vm._v("Correlation measures how two different investments move in comparison with each other. A perfect positive correlation means two investments rise and fall exactly alike, so if one tanks so does the other. A perfect negative correlation means that they move in opposite directions, so if one tanks, the other soars. Low correlation means they move the same way, but not at the same rate.")]), _vm._v(" "), _c('hr', {
    staticClass: "hr2"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When real estate has a negative correlation with the rest of your portfolio, it moves in the opposite direction. If your other assets take a nosedive, your real estate investments will gain value.")])]), _c('p', {
    staticClass: "shead"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("Different Kinds of Real Estate Investments")])])]), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_c('p', {
    staticClass: "indentb"
  }, [_vm._v("Investing in real estate doesn’t mean you have to own property, though that’s what jumps into most people’s minds when they think about it. There are several different ways to invest in real estate to help you build wealth, including owning any of the following:")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_vm._v("• Residential rental properties")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_vm._v("• Commercial properties")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_vm._v("• Real estate industry–related stocks")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_vm._v("• Mortgage-backed securities")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_vm._v("• Mortgage debt funds")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_vm._v("• Real estate investment trusts (REITs)")]), _vm._v(" "), _c('p', {
    staticClass: "bullb"
  }, [_vm._v("• Real estate mutual funds and exchange-traded funds (ETFs)")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Inside each of those categories you’ll find even more choices. For example, commercial real estate could be anything from a shopping mall to an office park to a hospital. Residential rental properties include single-family homes, apartment buildings, and retirement communities. So even within the real estate portion of your portfolio you can hold diverse investments.")]), _vm._v(" "), _c('p', {
    staticClass: "shead"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("Different Areas")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In addition to diversifying among different types of real estate, you can also spread out risk by investing in several geographical areas. That way if one area gets hit hard by wildfires, storms, or a toxic chemical spill, you’ll still have income-producing assets in other places that remain unaffected.")])]), _c('h4', {
    staticClass: "h4a"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("INFLATION CUSHION")])])]), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Back in 1980, the median rent across the United States was $243 a month. Ten years later, that expense jumped to $447 per month. Fast-forward to 2015, and median monthly rent had risen to $942 per month. That’s inflation: paying more money for the exact same thing. That’s bad for tenants, but great for landlords and other real estate investors who can shield themselves from the inflation effect by passing it on to their tenants.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Inflation happens over time, with most prices tending to go up steadily. When that happens, your purchasing power decreases: $100 today buys more than it will twenty years from now. So for your money to really work for you, it has to earn at least as much as the inflation rate—but more is better.")]), _vm._v(" "), _c('p', {
    staticClass: "box-head"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("The Inflation Rate")])]), _vm._v(" "), _c('hr', {
    staticClass: "hr1"
  }), _vm._v(" "), _c('p', {
    staticClass: "box"
  }, [_vm._v("In the US, inflation typically runs at about 2 percent to 3 percent every year. Some years, though, inflation has been negative (that’s called deflation). Other years, the rate has been much higher or lower than the norm: the inflation rate in 2015 averaged just 0.1 percent, while in 1990 it hit 6.0 percent.")]), _vm._v(" "), _c('hr', {
    staticClass: "hr2"
  }), _vm._v(" "), _c('p', {
    staticClass: "shead1"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("Appreciation")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In virtually all cases, real estate values appreciate (rise) over time. The longer you hold on to a piece of property, the more it will be worth. That makes real estate investing a natural foil for inflation.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("Throughout the United States, residential real estate values have increased (on average) around 3.4 percent every year since 1991, and commercial property values typically increase 2 percent to 3 percent annually. Local markets, though, can see much bigger swings (in both ")]), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("directions). For example, according to ATTOM Data, home prices in the Seattle area are increasing more rapidly than in most of the US.")])]), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("In addition, with real estate investments you have some control of your property value. You can make repairs, renovations, or additions that increase how much the property is worth.")]), _vm._v(" "), _c('p', {
    staticClass: "shead"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("Pass It Along")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As mentioned earlier, investing in rental real estate can protect you from the effects of inflation: rising costs get passed through to tenants in the form of rent increases. This benefit works especially well when the property was bought with cash or with a fixed-rate loan. That means at least some of your costs will not increase even as you’re able to charge more rent, helping further to protect your purchasing power.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This holds true with investments in commercial and industrial properties as well, something which surprises many novice real estate investors. Though these types of properties typically work with long-term leases, those agreements almost always come with “elevator” (also called “rent escalation”) clauses, meaning the rent will increase over time. Sometimes that’s at the landlord’s discretion, and other times it’s based on a formula. In either case, when property costs rise due to inflation, rents on these properties increase as well.")]), _vm._v(" "), _c('h4', {
    staticClass: "h4a"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("STEADY RETURNS, REDUCED RISK")])])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("Real estate investing offers multiple paths for earning income, some that deliver monthly and others that pay off over decades. Real estate assets are productive, bringing in regular cash (mostly from rents but possibly from other sources, such as timber sales, for example). ")]), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v("They also gain value over time, whether through market appreciation or more hands-on methods (such as renovation).")])]), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("That’s how investors can use real estate to balance their portfolios, to stabilize returns with steady income, and to reduce their overall risk by adding a safer asset class without sacrificing long-term growth. Most stock investors are looking to capture rapid growth, a highly risky proposition. Bond investors are often looking for low-risk, reliable income, without the prospect for explosive growth. Real estate investors get the best of both: stable current income and proven long-term growth potential.")]), _vm._v(" "), _c('p', {
    staticClass: "shead"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("The Volatility Factor")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Real estate prices move around slowly, while stock prices move around at rocket speed. That slow movement leads to less volatility in real estate than the constant heart-wrenching ups and downs of the stock market (think canoeing on a lake versus whitewater rafting).")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("That’s why comparing returns on real estate investments and stocks is like comparing apples to soufflés; they belong together under the same general umbrella of assets, but they aren’t alike in most other ways. To make it a more useful comparison, experts look at risk-adjusted returns—and that’s where real estate investments outshine many other asset classes.")]), _vm._v(" "), _c('p', {
    staticClass: "box-head"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("Risk-Adjusted Returns")])]), _vm._v(" "), _c('hr', {
    staticClass: "hr1"
  }), _vm._v(" "), _c('p', {
    staticClass: "box"
  }, [_vm._v("When you invest money, you’re taking a risk (that you’ll lose your money) to earn a return (more money). Riskier investments (such as stocks) usually promise higher returns to entice investors; after all, if the dollar returns were equal, people would pick the safer bet. Risk-adjusted returns take that into account, by looking at the real rate of return relative to its risk factor.")]), _vm._v(" "), _c('hr', {
    staticClass: "hr2"
  })]), _c('p', {
    staticClass: "shead1"
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("Stable Income Streams")])])]), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Steady cash flows are a staple of most forms of real estate investing. Rental properties, whether you own them directly or through a fund, generate positive cash flow: rent payments cover property expenses with cash left over. That strategy works whether you have one rental property or invest in funds that hold thousands of them.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Even better, real estate investing offers "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("passive")]), _vm._v(" income, meaning you just sit back and collect money rather than trading your time for money (as with a traditional job). That frees up your time for whatever you want to do with it, whether that’s delving into other money-making ventures or traveling the world.")]), _vm._v(" "), _c('h4', {
    staticClass: "h4a"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("REAL ESTATE CREATES WEALTH")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Building true wealth takes time—it doesn’t happen overnight; in fact, in some cases, it takes generations. Many of America’s wealthiest families have built their fortunes on a foundation of real estate. This sturdy asset class ranks among the top choices for members of the “three comma club” (billionaires) according to CNBC.")]), _vm._v(" "), _c('p', {
    staticClass: "shead"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("The Path to Wealth")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Real estate is a proven wealth generator, providing all the ingredients needed to build a secure, income-generating nest egg. This single asset class offers investors a steady cash inflow (through rents), growth (through property value appreciation), and the opportunity to transform relatively small amounts of capital into much larger assets (through the use of leverage).")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("Consider this: if you have $20,000 to invest, you can either buy $20,000 of stocks or bonds, or put a $20,000 down payment on a ")]), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v("$100,000 property. Which seems like the most direct path toward wealth?")])]), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_c('p', {
    staticClass: "shead"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("Holding On to Your Money")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Real estate investing offers unmatched tax advantages that help you keep more of your earnings than you would with other types of investments. That brings the double benefit of increasing your net worth and leaving you with more cash to acquire more income-producing assets.")]), _vm._v(" "), _c('p', {
    staticClass: "indentb"
  }, [_vm._v("Examples of these unique tax benefits include (see Chapter 6 for full details):")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_vm._v("• Depreciation (to reduce income taxes)")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_vm._v("• Deferred capital gains opportunities through 1031 exchanges")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_vm._v("• Tax-free cash flow through leverage")]), _vm._v(" "), _c('p', {
    staticClass: "bullb"
  }, [_vm._v("• No FICA taxes on rental income")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("These are just a few of the ways the tax code specifically benefits real estate investors, and these key advantages build up over time, giving you more capital to invest.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-88b80c72","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch01_sub02.vue
// module id = 75
// module chunks = 0